import React, { useState, useEffect, RefObject } from 'react';
import Dropdown from '../../../../basic/dropdown';
import { useUserProfile } from '../../../../../providers/user-provider';
import { useConfig } from '../../../../../providers/config-provider';
import { useRouter } from '../../../../../common/hooks/useRouter';
import { useContent } from '../../../../../providers/content/hook';
import { useRegion } from '../../../../../providers/region-provider';
import { TyRegionMessages } from '../../../../../types';
import { getTextFromHtml } from '../../../../../utils/common';
import { getRegionsFromHeaderContent } from '../../../../../utils/regionUtils';

interface RegionNavLinksProps {
  readonly navRef: RefObject<HTMLDivElement>;
  readonly regionMessages: TyRegionMessages;
}
export default function RegionNavLink({ navRef, regionMessages }: RegionNavLinksProps) {
  const { content } = useContent();
  const { userProfile } = useUserProfile();
  const { selectedRegion, setSelectedRegion } = useRegion();
  const { config } = useConfig();
  const { navigate } = useRouter();
  const [showDropdown, setShowDropdown] = useState(false);
  // const regions = content?.header?.regions?.value;
  const regions = getRegionsFromHeaderContent(content);
  const mappingRules = config?.rules?.mappingRules;

  const onClickHandler = (region: string) => {
    const mappedRegion = mappingRules?.find(
      rule => rule?.regionCode?.toLocaleLowerCase() === region.toLocaleLowerCase()
    );
    setSelectedRegion(
      regions?.find(
        (reg: { key: any }) =>
          reg.key.toLocaleLowerCase() === mappedRegion?.regionCode.toLocaleLowerCase()
      )
    );
    navigate('', region);
  };

  useEffect(() => {
    if (showDropdown) {
      if (navRef && navRef.current) {
        navRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }
  }, [showDropdown]);

  return (
    <div className="w-full px-4">
      <div className="font-[500] text-sm mb-3 text-white">{getTextFromHtml(regionMessages?.title)}</div>
      <Dropdown
        id="regionDropdownMobile"
        isMobile={true}
        options={regions}
        clickHandler={onClickHandler}
        iconName="location"
        selected={selectedRegion}
        disabled={!!userProfile?.region}
        toolTipMessage={getTextFromHtml(regionMessages?.region_change_tooltip_msg)}
        setShowDropdownState={(val: boolean) => setShowDropdown(val)}
        color='text-white'
      />
    </div>
  );
}
